import { FulfillmentChannelOrderService } from 'common/data';
import { BaseStore } from 'core/stores';

class FulfillmentChannelOrderStore extends BaseStore {
	constructor(rootStore) {
		super(new FulfillmentChannelOrderService(rootStore.app.baasic.apiClient));
	}
}

export default FulfillmentChannelOrderStore;
